import { UnsubscriptionError } from 'rxjs';

export class AuthInfo {
    constructor(public token:string, 
        public refreshToken: string, 
        public expiresAt: Date, 
        public auxTime: number) { }
} 

export class LoginInfo {
    constructor(public username:string, 
        public password: string) { }
} 

export class LoginResponseInfo {
    constructor(public isOk:boolean, 
        public message: string) { }
} 

export class RefreshRequestInfo {
    constructor(public token:string, 
        public refreshToken: string) { }
} 

export class RefreshResponseInfo {
    constructor(public token:string, 
        public expiresAt: Date,
        public auxTime: number) { }
} 

export interface UserInfo {
    area: string;
    role: string;
    username: string;
    empresaId: number;
    empresaRazaoSocial: string;
    empresasId: string;
    id: number;
    usuarioId: number;
    exp: number;
    iss: string;
    aud: string;
} 